import React, { useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { FIELD_TYPES } from 'utility/constants';
import SelectInline from 'components/Inputs/inline/Select';
import { getDataQAForInput } from 'components/Inputs/helpers';

export default function TimezoneInline({
  value,
  onSubmit,
  field,
  children: selectEl,
  rootCloseEvent,
  entityId,
  ...others
}) {
  const { t } = useTranslation();
  const options = useMemo(() => {
    return (field.options || []).map((opt) => ({
      value: opt.code,
      label: opt.name,
    }));
  }, [field]);
  return (
    <SelectInline
      onSubmit={(opt) => onSubmit(opt && opt.value)}
      field={field}
      rootCloseEvent={rootCloseEvent}
      entityId={entityId}
      {...others}
    >
      {React.cloneElement(selectEl, {
        field: field,
        value,
        options,
        ...getDataQAForInput(field.id, field.fieldType),
        placeholder:
          selectEl.props.placeholder ||
          FIELD_TYPES.Timezone.localizedPlaceholder(t),
      })}
    </SelectInline>
  );
}

TimezoneInline.propTypes = {
  value: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
};

TimezoneInline.defaultProps = {
  value: null,
};
